// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import UserAvatar from '../../../../../components/userAvatar/UserAvatar';

// Components
import FileInput from '../../../../../components/tools/files/FileInput';
import Button from '../../../../../components/buttons/Button';

// Constants
import { USER_AVATAR_SIZES } from '../../../../../../common/users/userConstants';

// Styles
import './AvatarPicker.scss';
import { getUserImage } from '../../../../../../common/users/utils/userPropertyUtils';

class AvatarPicker extends React.Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
    }

    openFileSelect = () => {
        this.fileInputRef.current && this.fileInputRef.current.click();
    };

    render() {
        const {
            user,
            uploadFile,
            connectFileDropTarget,
            fileIsHovered,
            fileCanDrop,
            attachment,
            cleanUserAttachment,
            dispatchRemoveCurrentUserAvatar,
        } = this.props;

        const classes = classNames('AvatarPicker overlay-parent', {
            hovered: fileIsHovered && fileCanDrop,
        });

        const hasImage = !!getUserImage(user);
        const isUploading = attachment && attachment.get('fetching');

        return connectFileDropTarget(
            <div className={classes}>
                <FileInput ref={this.fileInputRef} id="avatar" uploadFile={uploadFile} />

                <div className="avatar-container">
                    <UserAvatar
                        user={user}
                        size={USER_AVATAR_SIZES.LARGE}
                        attachment={attachment}
                        onImageLoadCb={cleanUserAttachment}
                    />
                    {hasImage && (
                        <div className="remove-image-overlay">
                            <Button className="remove-button" onClick={dispatchRemoveCurrentUserAvatar}>
                                Remove
                            </Button>
                        </div>
                    )}
                </div>

                {!isUploading && (
                    <Button className="upload-button" onClick={this.openFileSelect}>
                        {hasImage ? 'Change' : 'Upload photo'}
                    </Button>
                )}
            </div>,
        );
    }
}

AvatarPicker.propTypes = {
    user: PropTypes.object.isRequired,
    attachment: PropTypes.object,
    uploadFile: PropTypes.func,
    fileIsHovered: PropTypes.bool,
    fileCanDrop: PropTypes.bool,
    connectFileDropTarget: PropTypes.func,
    cleanUserAttachment: PropTypes.func,
    dispatchRemoveCurrentUserAvatar: PropTypes.func,
};

export default AvatarPicker;
